import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "race-points" }
const _hoisted_2 = { class: "bar" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("line", {
  x1: "3",
  x2: "19.5",
  y1: "8",
  y2: "28"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("line", {
  x1: "33",
  x2: "16.5",
  y1: "8",
  y2: "28"
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("line", {
  x1: "28",
  x2: "8",
  y1: "3",
  y2: "19.5"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("line", {
  x1: "28",
  x2: "8",
  y1: "33",
  y2: "16.5"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 1,
  class: "no-players"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "Er zijn geen voorspellingen van anderen.", -1)
const _hoisted_20 = [
  _hoisted_19
]

import {onMounted, ref, watch} from 'vue';
	import {RaceTypes} from "../utils/RaceTypes";
	import {SortArrayByMultipleKeys} from "../utils/Sorting";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'RacePoints',
  props: {
    predictions: {},
    players: {},
    race: {}
  },
  setup(__props: any) {

	const props = __props;

	const showPoints = ref(false);
	const sortedPredictions = ref(new Map());
	const drivers = ref(new Map());
	const players = ref(new Map());
	const localPlayer = ref(0);
	const errorPredictions = ref([]);
	const result = ref([]);
	const pointsTotal = ref(new Map());

	const types = RaceTypes;

	onMounted(() => {
		localPlayer.value = JSON.parse(localStorage.player);


		props.players.forEach(x => {
			players.value.set(x.id, x);
		});
	});

	watch(() => props.predictions, () => {
		sortPredictions();
	});

	//Executed before props.prediction
	watch(() => props.race, (newValue) => {
		newValue.drivers.forEach(x => {
			drivers.value.set(x.id, x);
		});

		result.value = newValue.drivers.filter(x => x.position >= 0 && x.position < 3 && x.position != null);
	});

	function sortPredictions() {
		if(props.predictions == undefined)
			return;

		const predictions = [...props.predictions];
		predictions.sort((a, b) => {
			if(a.player_id > b.player_id)
				return 1;
			if(a.player_id < b.player_id)
				return -1;
			if(a.position > b.position)
				return 1;
			if(a.position < b.position)
				return -1;
		});

		let array = [];
		let playerId = 0;
		let total = 0;

		//Separate predictions by player and calculate points
		for(let i = 0; i < predictions.length; i++) {
			const value = predictions[i];

			if(playerId == 0)
				playerId = value.player_id;
			else if(playerId != value.player_id) {
				sortedPredictions.value.set(playerId, array);
				pointsTotal.value.set(playerId, total);
				playerId = value.player_id;
				array = [];
				total = 0;
			}

			if(drivers.value.has(value.driver_id)) {
				value.points = calculateScore(value);
				total += value.points;
				array.push(value);
			}
			else
				errorPredictions.value.push(value);

			if(i == predictions.length - 1) {
				sortedPredictions.value.set(playerId, array);
				pointsTotal.value.set(playerId, total);
			}
		}

		//Sort predictions by points
		const pointsSorted = [];
		pointsTotal.value.forEach((value, key) => {
			pointsSorted.push({id: key, points: value, name: players.value.get(key).name});
		});

		const map = new Map();
		SortArrayByMultipleKeys(pointsSorted, ['points', 'name'], [true, false]).forEach(value => {
			map.set(value.id, sortedPredictions.value.get(value.id));
		});

		sortedPredictions.value = map;
	}

	function calculateScore(prediction: object) {
		let points = 0;

		result.value.forEach(driver => {
			if(prediction.driver_id == driver.id) {
				points += 1;
				if(prediction.position == driver.position)
					points += 3 - driver.position;
				
				return;
			}
		});

		return points;
	}

	function togglePoints() {
		showPoints.value = !showPoints.value;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.race.date > Date.now() / 1000)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Race nog niet gereden."))
          : (pointsTotal.value.has(localPlayer.value.id))
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Punten verdiend: " + _toDisplayString(pointsTotal.value.get(localPlayer.value.id) * (_ctx.race.type + 1)), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, "Punten verdiend: 0")),
        _createElementVNode("p", null, _toDisplayString(`${_unref(types)[_ctx.race.type]}: ${_ctx.race.type + 1}x punten`), 1)
      ]),
      _createElementVNode("button", { onClick: togglePoints }, [
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass({hidden: !showPoints.value}),
          "stroke-width": "6"
        }, _hoisted_9, 2)),
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass({hidden: showPoints.value}),
          "stroke-width": "6"
        }, _hoisted_12, 2))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["points", {hidden: !showPoints.value}])
    }, [
      _hoisted_13,
      (sortedPredictions.value.size > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(sortedPredictions.value, ([playerId, predictions]) => {
            return (_openBlock(), _createElementBlock("div", {
              key: predictions,
              class: "players"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["row", {'local-player': localPlayer.value.id == playerId}])
              }, [
                _createElementVNode("h3", null, _toDisplayString(players.value.get(playerId).name), 1),
                (result.value.length > 0)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_14, _toDisplayString(pointsTotal.value.get(playerId) * (_ctx.race.type + 1)), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(predictions, (prediction) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: prediction,
                  class: "row"
                }, [
                  _createElementVNode("span", null, _toDisplayString(prediction.position + 1) + ". " + _toDisplayString(drivers.value.get(prediction.driver_id).name), 1),
                  (result.value.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (prediction.points > 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " 1+" + _toDisplayString(prediction.points - 1), 1))
                          : (prediction.points > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 1 "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, " 0 "))
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
    ], 2)
  ]))
}
}

})